import React from "react";
import IRMA_Status_History from "@models/IRMA_Status_History";
import OwLabel from "@components/shared/OwLabel/OwLabel";
import UIService from "@services/UIService";
import "./RmaStatusHistory.scss";
import UserService from "@services/UserService";

type Props = {
    statusHistories: IRMA_Status_History[];
};

export const RmaStatusHistory = (props: Props) => {
    const { statusHistories } = props;

    const formatDate = (date: Date | string | null | undefined): string => {
        if (!date) return "-";
        return UserService.parseLastUpdated(new Date(date), true);
    };

    const sortedHistory = [...statusHistories].sort((a, b) => {
        const dateA = new Date(a.created_at).getTime();
        const dateB = new Date(b.created_at).getTime();
        return dateB - dateA; // Most recent first
    });

    return (
        <div className="RmaStatusHistory">
            {sortedHistory.length > 0 ? (
                <div className="timeline">
                    {sortedHistory.map((history, index) => (
                        <div key={history.id} className="timeline-item">
                            <div className="timeline-marker"></div>
                            <div className="timeline-content">
                                <div className="d-flex justify-content-between align-items-start mb-2">
                                    <div>
                                        <strong>
                                            <OwLabel title={history.old_status?.name || "created"} /> →{" "}
                                            <OwLabel title={history.new_status?.name || "-"} noBottomMargin={true} />
                                        </strong>
                                        {history.User && (
                                            <span className="text-muted ms-2">
                                                <OwLabel title="by" noBottomMargin={true} /> {history.User.name}
                                            </span>
                                        )}
                                    </div>
                                    <span className="text-muted font-small">{formatDate(history.created_at)}</span>
                                </div>
                                {history.notes && (
                                    <div className="text-muted">
                                        <OwLabel title="notes" noBottomMargin={true} />: {history.notes}
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <div className="text-muted">
                    <OwLabel title="no_history_available" />
                </div>
            )}
        </div>
    );
};
